import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayeeEngagementFilterOptions } from "../../../../Payees/hooks/usePayeeEngagementFilterOptions";
import { usePayeeFilterOptions } from "../../../../Payees/hooks/usePayeeFilterOptions";

export function useBuildConfig() {
  const payeeOptions = usePayeeFilterOptions({
    filter: {
      "engagements.isWorkLoggingEnabled": true
    }
  });

  const assignmentOptions = usePayeeEngagementFilterOptions({
    filter: {
      "engagements.isWorkLoggingEnabled": true
    }
  });

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [];

    config.push({
      title: "Contractor",
      name: "payeeId",
      type: "select",
      apiOptions: payeeOptions
    });

    config.push({
      title: "Assignment",
      name: "assignmentId",
      type: "select",
      apiOptions: assignmentOptions
    });

    config.push({
      title: "Date range",
      name: "dateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    return config;
  }, [payeeOptions, assignmentOptions]);
}
